import React from 'react';
import Image from 'atomic/image';
import getBadge from 'helpers/get-badge';
import { BadgeType } from 'interfaces/dealer-opinions.interface';
import opineoQualitySvg from 'assets/images/icons/certyfikat_opineo_bez_napisu.svg';

interface DealerBadgesProps {
    isOpineoQuality?: boolean;
    dealerBadge?: {
        name: string;
        type: BadgeType;
    };
}

const DealerBadges: React.FC<DealerBadgesProps> = ({ dealerBadge, isOpineoQuality }) => {
    if (isOpineoQuality) {
        return <Image src={opineoQualitySvg} alt="Certyfikat Opineo" title="Certyfikat Opineo"
            width={60} height={40} show={true}
            loading="lazy"
        />;
    }

    if (dealerBadge) {
        return <Image src={getBadge(dealerBadge.type)} alt={dealerBadge.name} title={dealerBadge.name}
            width={35} height={40} show={true}
            loading="lazy"
        />;
    }

    return null;
};

export default DealerBadges;
